import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { ConversationApiMapper, LlmProviderApiMapper, MessageApiMapper, PromptTemplateApiMapper, SkillApiMapper, AttachmentFileApiMapper } from './data-sources/apis/mappers';
import { CONVERSATION_API, ConversationApi, LLM_PROVIDER_API, LlmProviderApi, MESSAGE_API, MessageApi, PROMPT_TEMPLATE_API, PromptTemplateApi, SKILL_API, SkillApi } from './data-sources/apis';
import { MessageStreamingApi, MESSAGE_STREAMING_API } from './data-sources/app-sync-graphql';
import { AI_WEB_MODULE_CONFIG } from './ai-web.module.config';
export var apiProviders = [{
  provide: ConversationApiMapper,
  useValue: new ConversationApiMapper()
}, {
  provide: MessageApiMapper,
  useValue: new MessageApiMapper()
}, {
  provide: SkillApiMapper,
  useValue: new SkillApiMapper()
}, {
  provide: PromptTemplateApiMapper,
  useValue: new PromptTemplateApiMapper()
}, {
  provide: LlmProviderApiMapper,
  useValue: new LlmProviderApiMapper()
}, {
  provide: AttachmentFileApiMapper,
  useValue: new AttachmentFileApiMapper()
}, {
  provide: AxiosInstanceBuilder,
  useFactory: function useFactory(config) {
    return new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    });
  },
  inject: [AI_WEB_MODULE_CONFIG]
}, {
  provide: CONVERSATION_API,
  useFactory: function useFactory(axiosInstanceBuilder, conversationMapper) {
    return new ConversationApi(axiosInstanceBuilder.toInstance(), conversationMapper);
  },
  inject: [AxiosInstanceBuilder, ConversationApiMapper]
}, {
  provide: MESSAGE_API,
  useFactory: function useFactory(axiosInstanceBuilder, messageMapper) {
    return new MessageApi(axiosInstanceBuilder.toInstance(), messageMapper);
  },
  inject: [AxiosInstanceBuilder, MessageApiMapper]
}, {
  provide: SKILL_API,
  useFactory: function useFactory(axiosInstanceBuilder, skillMapper) {
    return new SkillApi(axiosInstanceBuilder.toInstance(), skillMapper);
  },
  inject: [AxiosInstanceBuilder, SkillApiMapper]
}, {
  provide: PROMPT_TEMPLATE_API,
  useFactory: function useFactory(axiosInstanceBuilder, promptTemplateMapper) {
    return new PromptTemplateApi(axiosInstanceBuilder.toInstance(), promptTemplateMapper);
  },
  inject: [AxiosInstanceBuilder, PromptTemplateApiMapper]
}, {
  provide: LLM_PROVIDER_API,
  useFactory: function useFactory(axiosInstanceBuilder, llmProviderMapper) {
    return new LlmProviderApi(axiosInstanceBuilder.toInstance(), llmProviderMapper);
  },
  inject: [AxiosInstanceBuilder, LlmProviderApiMapper]
}, {
  provide: MESSAGE_STREAMING_API,
  useFactory: function useFactory(messageMapper) {
    return new MessageStreamingApi(messageMapper);
  },
  inject: [MessageApiMapper]
}];